import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [hasLoggedIn, setHasLoggedIn] = useState(false);

  const login = () => {
    setHasLoggedIn(true);
  };

  const logout = () => {
    setHasLoggedIn(false);
  };

  const value = {
    hasLoggedIn,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
